import {AnyAction} from "redux";
import {SET_MAP_OFFSET} from "./action";


/**
 * set the offset of the map
 * @param ox
 * @param oy
 */
export function setMapOffset(ox: number, oy: number) : AnyAction
{
    return {type: SET_MAP_OFFSET, payload: {ox, oy}};
}


// WEBPACK FOOTER //
// ./src/ts/store/actions/mapOffset.ts